var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import * as React from "react";
import { connect } from "react-redux";
import { getUserAccessStateById, hasWorkspaceClaims, hasExperimentationGroupClaims } from "./UserAccess.selectors.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const mapState = (state, ownProps) => {
  var _a, _b;
  const { experimentationGroupId, claims } = ownProps;
  const workspaceId = ((_b = (_a = state.currentUserDetails.userAffinity) == null ? void 0 : _a.data) == null ? void 0 : _b.workspaceId) || "";
  const userAccessState = getUserAccessStateById(workspaceId, state);
  const hasWsClaims = hasWorkspaceClaims(workspaceId, claims, state);
  const hasEgClaims = !!experimentationGroupId ? hasExperimentationGroupClaims(workspaceId, experimentationGroupId, claims, state) : false;
  if (hasEgClaims && !hasWsClaims) {
    EnvironmentService.setWpsStatus(__spreadProps(__spreadValues({}, EnvironmentService.getWpsStatus()), {
      experimentGroup: experimentationGroupId
    }));
  }
  return {
    hasClaims: hasEgClaims || hasWsClaims,
    workspaceClaims: userAccessState.workspaceClaims || {},
    experimentationGroupClaims: userAccessState.experimentationGroupClaims || {}
  };
};
class Component extends React.Component {
  render() {
    const { hasClaims, workspaceClaims, experimentationGroupClaims } = this.props;
    return this.props.render({
      hasClaims,
      workspaceClaims,
      experimentationGroupClaims
    });
  }
}
const ClaimCheckDataProvider = connect(
  mapState,
  {}
)(Component);
export {
  ClaimCheckDataProvider as default
};
//# sourceMappingURL=ClaimCheckDataProvider.js.map
